<template>
  <div>
    <h1>Manage Nominees</h1>
    <button v-if="currentYearNotFound" @click="addYear()">Add year</button>
    <div class="form-group">
      <label>Select a Year</label>
      <select v-model="selectedYear" class="form-control">
        <option v-for="oscarYear in oscarYears" :key="oscarYear.year.name">{{ oscarYear.year.name }}</option>
      </select>
    </div>
    <div>
      <h3>Deactivate Voting</h3>
      <ul class="deactivateVotingBlock">
        <li>
          <label>
            <input
              type="radio"
              name="deactivateVoting"
              @click="deactivateVoting(true)"
              :checked="votingDeactivated"> <span>True</span></label>
        </li>
        <li>
          <label>
            <input
              type="radio"
              name="deactivateVoting"
              @click="deactivateVoting(false)"
              :checked="!votingDeactivated"> <span>False</span></label>
        </li>
      </ul>
    </div>
    <ul class="list-group categories-list">
      <li v-for="category in currentYearCategories" :key="category['.key']" class="list-group-item" :class="{ inactiveItem: currentCategory && currentCategory !== category['.key'] }">
        <h3 class="d-inline-block"><img src="../../images/oscar-statue.png">{{ category.name }}</h3>
        <button class="btn btn-warning btn-sm float-right" @click="addNominee(category)" v-if="currentCategory !== category['.key']" :disabled="currentCategory && currentCategory !== category['.key']">Add Nominee</button>
        <ul class="nominee-list" v-if="category.nominees">
          <li v-for="(nominee, index) in category.nominees" :key="index" class="nominee-block"  @click="setWinner(category, nominee)">
            <img class="winner" :class="{ isWinner: nominee.winner }" src="../../images/oscar-statue.png"><p>{{ nominee.nomineeName }} - <b>{{ nominee.nomineeMovie }}</b></p>
          </li>
        </ul>
        <nominee-form v-if="currentCategory === category['.key']" @closeForm="currentCategory=null" @saveNominee="saveNominee"></nominee-form>
      </li>
    </ul>
  </div>
</template>

<script>
import { db } from '../../firebase/';
import NomineeForm from './NomineeForm';

export default {
  name: 'Nominees',
  data() {
    return {
      errorMessage: null,
      oscarYears: [],
      categories: [],
      selectedYear: (new Date()).getFullYear(),
      currentCategory: null
    };
  },
  firebase: {
    oscarYears: {
      source: db.ref('years')
    },
    categories: {
      source: db.ref('categories')
    }
  },
  methods: {
    deactivateVoting(onOff) {
      this.$firebaseRefs.oscarYears.child(this.currentYear['.key']).child('deactivated').set(onOff);
    },
    setWinner(category, selectedNominee) {
      const currentYear = this.oscarYears.find(year => year.year.name === this.selectedYear);
      for (let nominee in currentYear.year.categories[category['.key']].nominees) {
        if (currentYear.year.categories[category['.key']].nominees[nominee].nomineeName === selectedNominee.nomineeName && !currentYear.year.categories[category['.key']].nominees[nominee].winner) {
          this.$firebaseRefs.oscarYears.child(currentYear['.key']).child('year').child('categories').child(category['.key']).child('nominees').child(nominee).child('winner').set(true);
        } else {
          this.$firebaseRefs.oscarYears.child(currentYear['.key']).child('year').child('categories').child(category['.key']).child('nominees').child(nominee).child('winner').set(false);
        }
      }
    },
    addNominee(category) {
      this.currentCategory = category['.key'];
    },
    saveNominee(nominee) {
      const currentYear = this.oscarYears.find(year => year.year.name === this.selectedYear);

      if (!currentYear.year.categories[this.currentCategory].nominees) {
        currentYear.year.categories[this.currentCategory].nominees = {
          0: nominee
        };
      } else {
        let keyName = Object.keys(currentYear.year.categories[this.currentCategory].nominees).length;
        currentYear.year.categories[this.currentCategory].nominees[keyName] = nominee;
      };

      let nomineeObj = currentYear.year.categories[this.currentCategory].nominees;

      this.$firebaseRefs.oscarYears.child(currentYear['.key']).child('year').child('categories').child(this.currentCategory).child('nominees').set(nomineeObj);

      this.currentCategory = null;
    },
    addYear() {
      let newYear = {
        year: {
          name: (new Date()).getFullYear(),
          categories: {}
        }
      };

      this.categories.forEach((category, index) => {
        newYear.year.categories[category['.key']] = { order: category.order, name: category.name };
      });

      db.ref('years').push(newYear);
    }
  },
  computed: {
    votingDeactivated() {
      if (this.currentYear) {
        return this.currentYear.deactivated;
      }
      return false;
    },
    currentYear() {
      return this.oscarYears.find(year => year.year.name === this.selectedYear);
    },
    currentYearNotFound() {
      return this.oscarYears.length && !this.oscarYears.find(oscarYear => oscarYear.year.name === (new Date()).getFullYear());
    },
    currentYearCategories() {
      let categories = [];

      let sortedCategories = [];
      const currentYear = this.oscarYears.find(year => year.year.name === this.selectedYear);
      if (currentYear) {
        for (let category in currentYear.year.categories) {
          categories.push({
            '.key': category,
            name: currentYear.year.categories[category].name,
            order: currentYear.year.categories[category].order,
            nominees: currentYear.year.categories[category].nominees
          });
        }
        sortedCategories = [...categories].sort((one, two) => { return one.order - two.order; });
      }

      return sortedCategories;
    }
  },
  components: {
    nomineeForm: NomineeForm
  }
};
</script>

<style lang="scss" scoped>
  @import '../../sass/config';
  .categories-list {
    margin: 0 0 50px;
  }
  .list-group-item {
    padding: 2rem;
  }
  .inactiveItem {
    background: #eee;
    opacity: .25;
  }
  .nominee-list {
    display: grid;
    grid-template-columns: 50% 50%;
    list-style-type: none;
    margin: 25px 0;
    padding: 0;

    li {
      margin: 0 0 25px;
    }

    li:nth-child(odd) {
      padding-right: 15px;
    }

    .nominee-block {
      cursor: pointer;
      display: grid;
      grid-template-columns: 25px auto;

      img {
        height: 30px;
        opacity: 0;
      }

      img.isWinner {
        opacity: 1;
      }
    }
  }
  h3 {
    display: inline-block;
  }
  .deactivateVotingBlock {
    display: inline-block;
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: inline-block;
      margin: 0 15px 25px;
      input {
        display: none;
      }
      span {
        display: inline-block;
        padding-left: 30px;
        position: relative;
      }
      span::before {
        border: 2px solid rgba(0, 0, 0, 0.125);
        border-radius: 50%;
        content: '';
        height: 20px;
        left: 0;
        position: absolute;
        top: 3px;
        width: 20px;
      }
      input:checked ~ span::before {
        background-color: $gold;
      }
    }
  }

  img {
    height: 50px;
    margin-right: 10px;
  }
</style>
